import { HTMLAttributes } from 'react';

import { DividerHorizontalIcon } from '@radix-ui/react-icons';
import { type Editor } from '@tiptap/react';

import { Button } from '../../../primitives/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../primitives/tooltip';

interface ButtonDividerProps extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  editor: Editor;
}

export function ButtonDivider({ className, editor }: ButtonDividerProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div>
          <Button
            aria-label="Agregar divisor"
            className={className}
            disabled={!editor.isEditable}
            size="icon"
            variant="ghost"
            onClick={() => editor.chain().focus().setHorizontalRule().run()}
          >
            <DividerHorizontalIcon className="size-4" />
          </Button>
        </div>
      </TooltipTrigger>
      <TooltipContent>
        <p className="flex flex-col">Agregar divisor</p>
      </TooltipContent>
    </Tooltip>
  );
}
